import { LANG_ISO_639_1 } from 'src/context/productFruits/components/productFruits/enums';

export const getProductFruitsLocale = (lng?: string) => {
  if (!lng) return LANG_ISO_639_1.EN;

  if (lng?.match(/^pt/)) {
    return 'PT_BR';
  }

  return lng?.toUpperCase();
};
